import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface SupportedCurrencies {
  transactionCurrencies: string[];
}

const getSupportedCurrencies = (makeCall: MakeCall) => () =>
  makeCall<SupportedCurrencies>(
    'GET',
    `/api/v2/payment/configuration/currencies`,
  );
export { getSupportedCurrencies };
